var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolarHouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 50,
    viewBox: "0 0 48 48",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Solar_Panel_House"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 8,
    fill: "#fff",
    r: 3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffba55"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 8,
    r: 3
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 15v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 2v-1a1 1 0 0 1 2 0v1a1 1 0 0 1 -2 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m34 9h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 9h-1a1 1 0 0 1 0-2h1a1 1 0 0 1 0 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.23 4.75a1 1 0 0 1 -.71-1.75l.71-.71a1 1 0 0 1 1.42 1.42c-.65.69-.89 1.04-1.42 1.04z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35.71 4.75c-.5 0-.65-.24-1.42-1a1 1 0 0 1 1.42-1.42l.71.71a1 1 0 0 1 -.71 1.71z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.94 14c-.5 0-.65-.23-1.42-1a1 1 0 0 1 1.42-1.42l.71.71a1 1 0 0 1 -.71 1.71z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m3 27h16v20h-16z",
    fill: "#dad7e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m3 27h16v20h-16z",
    fill: "#c6c3d8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 27h24v20h-24z",
    fill: "#dad7e5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 27v16h-17a5 5 0 0 1 -5-5v-11z",
    fill: "#edebf2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 27h-16l8-14z",
    fill: "#ef6833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 27h-24l-8-14h25z",
    fill: "#f16f39"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m43 27h-22l-8-14h23z",
    fill: "#f8834b"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 39h2a2 2 0 0 1 2 2v6a0 0 0 0 1 0 0h-6a0 0 0 0 1 0 0v-6a2 2 0 0 1 2-2z",
    fill: "#cc734c"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m27.82 20h-8.82l-2-4h9z",
    fill: "#5b9ad8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m26.82 18h-6.58a3.61 3.61 0 0 1 -3.24-2c-.05-.1-.19 0 8.91 0z",
    fill: "#82bcf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m36 20h-8.18c-1.12-2.45-.7-1.55-1.82-4h8z",
    fill: "#5b9ad8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m35 18h-5.89a3.41 3.41 0 0 1 -3.11-2h8z",
    fill: "#82bcf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.64 24h-8.64l-2-4h8.82c1.31 2.89 1.18 2.65 1.82 4z",
    fill: "#5b9ad8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m28.64 22h-6.4a3.61 3.61 0 0 1 -3.24-2c-.05-.1-.17 0 8.73 0z",
    fill: "#82bcf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m38 24h-8.36c-.7-1.55.06.12-1.82-4h8.18z",
    fill: "#5b9ad8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m37 22h-6.07a3.41 3.41 0 0 1 -3.11-2h8.18z",
    fill: "#82bcf4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32 31a1 1 0 0 1 -2 0v-3.78c-1.37-3-1.36-2.93-1.36-3.22h2.1c1.59 3.52 1.26 1.92 1.26 7z",
    fill: "#2c435e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m25 31h14v12h-14z",
    fill: "#ffba55"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m39 31v10h-8a4 4 0 0 1 -4-4v-6z",
    fill: "#ffde76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.05 39.68.56-1.68h-.61a1 1 0 0 1 -.95-1.32l1-3a1 1 0 0 1 1.9.64l-.56 1.68c.65 0 1.07-.07 1.42.42s.21.68-.86 3.9a1 1 0 0 1 -1.9-.64z",
    fill: "#5b9ad8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m47 48h-46a1 1 0 0 1 0-2h46a1 1 0 0 1 0 2z",
    fill: "#2c435e"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarHouse);
export default __webpack_public_path__ + "static/media/solar-house.557455dbbb4fcd4b37a2ed25479ec4a3.svg";
export { ForwardRef as ReactComponent };